<div class="card-inner-main-div">
    <div class="card-main-title">
        <h4 class="card-title">{{ 'Exposure' | translate }}<br>{{ 'Reduction Plan Items' | translate }}</h4>
    </div>
    <div class="tableColStyle">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">
                            <a>{{ 'Location' | translate }}</a>
                        </th>
                        <th scope="col">
                            <a>{{ 'Description' | translate }}</a>
                        </th>
                        <th scope="col">
                            <a>{{ 'Implemented' | translate }}</a>
                        </th>
                        <th scope="col">
                            <a>{{ 'Effectiveness' | translate }}</a>
                        </th>
                        <th class="blank-td" scope="col">
                            <a></a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><span class="font-700">Elkview</span></td>
                        <td><span class="">Intervention 1: Air Filter Upgrade</span></td>
                        <td class="">04/23/2022</td>
                        <td>90%</td>
                        <td>
                            <a class="view-report purple-text font-700">{{ 'View Report' | translate }}</a>
                        </td>
                    </tr>
                    <tr>
                        <td><span class="font-700">Greenhills</span></td>
                        <td><span class="">Vacuum setup in store</span></td>
                        <td class="">TBD</td>
                        <td class="blank-td"></td>
                        <td class="blank-td"></td>
                    </tr>
                    <!-- <tr *ngIf="exposureContribution && !exposureContribution.length">
                        <td colspan="5" class="no-data-available with-padding">No Data Available</td>
                    </tr> -->
                </tbody>
            </table>
        </div>
    </div>
</div>